<template>
  <wrapper>
    <loading-screen :isActive="isLoading">
      <main class="main-content-wrapper">
        <employee-log :logData="employeeLog" />
        <br />
        <employee-form @submit="handleSubmitData" :employee="employeeData" />
      </main>
    </loading-screen>
  </wrapper>
</template>

<script>
import EmployeeForm from "./Components/Form.vue";
import { Wrapper, LoadingScreen } from "../Layout";
import { alert } from "../../utils";
import cardProtectIcon from "../../assets/icon/card-protect-blue.svg";
import EmployeeLog from "./Components/EmployeeLog.vue";

export default {
  name: "CreateEmployee",
  components: {
    EmployeeForm,
    Wrapper,
    LoadingScreen,
    EmployeeLog,
  },
  data() {
    return {
      isLoading: false,
      employeeData: null,
      employeeLog: [],
      adminId: 0,
    };
  },
  methods: {
    async handleSubmitData(data) {
      const alertResponse = await alert({
        icon: cardProtectIcon,
        iconColor: "#1C68D933",
      }).fire({
        title: "Save Edit Profile",
        text: `Are you sure to save profile & roles ${data.fullName}?`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Save",
        cancelButtonText: "Cancel",
      });
      if (!alertResponse.isConfirmed) return;

      this.isLoading = true;
      try {
        const sentData = {
          ...data,
          adminId: this.adminId,
          userId: Number(this.$route.params.id),
        };
        const response = await this.$http.post(
          process.env.EDIT_EMPLOYEE,
          sentData,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status == 200) {
          alert().fire({
            title: "Success",
            text: `${data.fullName} data has been successfully changed`,
            icon: "success",
            confirmButtonText: "Okay",
          });
          this.getDetailData();
          this.getLogEmployee();
        } else {
          alert({ confirmButtonColor: "red" }).fire({
            title: "Failed",
            text:
              response.data.message ||
              `${data.fullName} data has been failed to save`,
            icon: "error",
            confirmButtonText: "Okay",
          });
        }
      } catch (error) {
        if (error.response) {
          return alert({ confirmButtonColor: "red" })
            .fire({
              title: "Failed",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Okay",
            })
            .then(() => {
              if (error.response.data.status == 401) {
                // this.handleLogout();
              }
            });
        }
        alert({ confirmButtonColor: "red" }).fire({
          title: "Failed",
          text: error.message,
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
      this.isLoading = false;
    },

    async getDetailData() {
      this.isLoading = true;
      try {
        const response = await this.$http.get(
          `${process.env.GET_DETAIL_EMPLOYEE}/${this.$route.params.id}`,
          {
            timeout: 600000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status == 200) {
          const detailData = response.data.content.data[0];
          this.employeeData = {
            fullName: detailData.employee_name,
            email: detailData.employee_email,
            phone: detailData.employee_phone.slice(2),
            birthDate: detailData.employee_birth_date,
            joinDate: detailData.employee_join_date,
            type: detailData.employee_type.toString(),
            division: detailData.employee_division,
            workLocation: detailData.region.map(el => ({ label: el, value: el })),
            permissions: {
              internal: detailData.employee_roles.internal_access,
              mobile: detailData.employee_roles.mobile_access,
              desktop: detailData.employee_roles.desktop_access,
            },
          };
        } else {
          alert({ confirmButtonColor: "red" })
            .fire({
              title: "Failed",
              text: response.data.message || `Data has been failed to reach`,
              icon: "error",
              confirmButtonText: "Okay",
            })
            .then(() => {
              this.$router.push({
                path: "/employee/search",
                query: {
                  employeeName: "",
                  employeeEmail: "",
                  userType: "",
                  division: "",
                  page: 1,
                },
              });
            });
        }
      } catch (error) {
        if (error.response) {
          return alert({ confirmButtonColor: "red" })
            .fire({
              title: "Failed",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Okay",
            })
            .then(() => {
              if (error.response.data.status == 401) {
                // this.handleLogout();
              }
            });
        }
        alert({ confirmButtonColor: "red" }).fire({
          title: "Failed",
          text: error.message,
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
      this.isLoading = false;
    },

    async getLogEmployee() {
      var employeeId = this.$route.params.id;
      try {
        const response = await this.$http.get(
          process.env.LOG_URL + "/employee/" + employeeId,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status === 200) {
          this.employeeLog = response.data.content;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getDetailData();
    this.getLogEmployee();
    const loggedAdminId = localStorage.getItem("admin_id");
    if (loggedAdminId) {
      this.adminId = Number(loggedAdminId);
    }
  },
};
</script>

<style scoped>
.main-content-wrapper {
  padding: 2rem 8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Employee/EditEmployee.vue